import React, { useEffect, useRef } from 'react'

//TODO: Add swipe up and down
const Swipe = ({
    children,
    minDistance = 150,
    minTime = 100,
    onSwipeLeft,
    onSwipeRight,
}) => {
    const swipeRef = useRef()

    const startX = useRef(0)
    const startTime = useRef(0)

    useEffect(() => {
        if (swipeRef.current) {
            /*
                Had to add it directly because of chrome breaking change
                Read more about it here:
                https://github.com/facebook/react/issues/8968
                https://developers.google.com/web/updates/2017/01/scrolling-intervention
             */
            swipeRef.current.addEventListener('touchstart', onTouchStart)
            // swipeRef.current.addEventListener('touchmove', e =>
            // e.preventDefault()
            // )
            swipeRef.current.addEventListener('touchend', onTouchEnd)
        }
    }, [swipeRef])

    const onTouchStart = e => {
        // e.preventDefault()
        startX.current = e.changedTouches[0].pageX
        startTime.current = new Date().getTime()
    }

    const onTouchEnd = e => {
        // e.preventDefault()
        const distanceTravelled = e.changedTouches[0].pageX - startX.current
        const timeTravelled = new Date().getTime() - startTime.current
        if (
            timeTravelled >= minTime &&
            Math.abs(distanceTravelled) >= minDistance
        ) {
            distanceTravelled < 0 ? onSwipeLeft() : onSwipeRight()
        }
    }

    return <div ref={swipeRef}>{children}</div>
}

export default Swipe
